import Vue from 'vue'
import Router from 'vue-router'
import MainView from '../components/view/MainView.vue'
import EmailConfirmationView from '../components/view/EmailConfirmationView'
import EmailCancellationView from '../components/view/EmailCancellationView'
import NewPwdView from '../components/view/NewPwdView'
import EmailChangeConfirmView from '../components/view/EmailChangeConfirmView'
import Maintenance from '../components/view/Maintenance'
import Store from '@/store';

Vue.use(Router)

const router = new Router({
  /* mode: 'history', */
  routes: [
    {
      path: '/',
      name: 'Reservation',
      component: MainView,
    }, {
      path: '/guest/confirm',
      name: 'EmailConfirmation',
      component: EmailConfirmationView,
    }, {
      path: '/guest/newpwd',
      name: 'NewPassword',
      component: NewPwdView,
    }, {
      path: '/guest/cancel',
      name: 'EmailCancellation',
      component: EmailCancellationView,
    }, {
      path: '/guest/change_email_confirm',
      name: 'EmailChangeConfirmation',
      component: EmailChangeConfirmView,
    }, {
      path: '/maintenance',
      name: 'Maintenance',
      component: Maintenance,
    }, {
      path: '/digital',
      name: 'Digital',
      component: () => import('../components/view/DigitalMainView.vue'),
      beforeEnter: (to, from, next) => {
        if (Store.getters.isDigitalMode) {
          next()
        } else {
          next('/')
        }
      },
    }, {
      path: '*',
      redirect: '/',
    },
  ],
})

export default router
